import { createEvent, restore, sample } from 'effector'
import { CreateBudgetItem } from './types'
import { fx, path } from '../../../../libs'
import { getSectionList } from '../../sections/list/model'
import { toPath } from '../../../../features/router'

export const setBudgetItem = createEvent<CreateBudgetItem>()

export const submitCreateBudgetItem = createEvent<CreateBudgetItem>()

export const sectionListForSelectMounted = createEvent()

export const $budgetItem = restore(setBudgetItem, {
  section: '',
  name: '',
})

export const createBudgetItem = fx<CreateBudgetItem, void>({
  method: 'POST',
  url: '/finance/budget_item',
})

sample({
  clock: submitCreateBudgetItem,
  fn: (budgetItem) => {
    return {
      url: `/finance/budget_item`,
      body: { ...budgetItem },
    }
  },
  target: createBudgetItem,
})

sample({
  clock: sectionListForSelectMounted,
  fn: () => ({}),
  target: getSectionList,
})

sample({
  clock: [createBudgetItem.doneData],
  target: toPath.prepend(path.finSystem.budgetItem.entry),
})
